<template>
<svg viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M89.5402 85.56H58.8802V79.27H83.2502V18.79H34.5102V37.37H28.2202V12.5H89.5402V85.56Z" fill="#D0D3D4"/>
<mask id="mask0_135_4986" style="mask-type:luminance" maskUnits="userSpaceOnUse" x="52" y="27" width="24" height="9">
<path d="M75.9202 27.41H52.6602V35.28H75.9202V27.41Z" fill="white"/>
</mask>
<g mask="url(#mask0_135_4986)">
<path d="M52.9602 27.41H52.6602V35.28H52.9602V27.41Z" fill="#F16623"/>
<path d="M53.26 27.41H52.96V35.28H53.26V27.41Z" fill="#F16623"/>
<path d="M53.5603 27.41H53.2603V35.28H53.5603V27.41Z" fill="#F16623"/>
<path d="M53.8601 27.41H53.5601V35.28H53.8601V27.41Z" fill="#F16623"/>
<path d="M54.1501 27.41H53.8501V35.28H54.1501V27.41Z" fill="#F16623"/>
<path d="M54.4504 27.41H54.1504V35.28H54.4504V27.41Z" fill="#F16523"/>
<path d="M54.7502 27.41H54.4502V35.28H54.7502V27.41Z" fill="#F16523"/>
<path d="M55.05 27.41H54.75V35.28H55.05V27.41Z" fill="#F16523"/>
<path d="M55.3503 27.41H55.0503V35.28H55.3503V27.41Z" fill="#F16523"/>
<path d="M55.6403 27.41H55.3403V35.28H55.6403V27.41Z" fill="#F06523"/>
<path d="M55.9401 27.41H55.6401V35.28H55.9401V27.41Z" fill="#F06423"/>
<path d="M56.2399 27.41H55.9399V35.28H56.2399V27.41Z" fill="#F06423"/>
<path d="M56.5402 27.41H56.2402V35.28H56.5402V27.41Z" fill="#F06323"/>
<path d="M56.84 27.41H56.54V35.28H56.84V27.41Z" fill="#F06323"/>
<path d="M57.1301 27.41H56.8301V35.28H57.1301V27.41Z" fill="#F06323"/>
<path d="M57.4304 27.41H57.1304V35.28H57.4304V27.41Z" fill="#EF6223"/>
<path d="M57.7302 27.41H57.4302V35.28H57.7302V27.41Z" fill="#EF6223"/>
<path d="M58.03 27.41H57.73V35.28H58.03V27.41Z" fill="#EF6123"/>
<path d="M58.3303 27.41H58.0303V35.28H58.3303V27.41Z" fill="#EF6123"/>
<path d="M58.6203 27.41H58.3203V35.28H58.6203V27.41Z" fill="#EF6023"/>
<path d="M58.9201 27.41H58.6201V35.28H58.9201V27.41Z" fill="#EE5F23"/>
<path d="M59.2199 27.41H58.9199V35.28H59.2199V27.41Z" fill="#EE5F23"/>
<path d="M59.5202 27.41H59.2202V35.28H59.5202V27.41Z" fill="#EE5E23"/>
<path d="M59.82 27.41H59.52V35.28H59.82V27.41Z" fill="#EE5E23"/>
<path d="M60.1101 27.41H59.8101V35.28H60.1101V27.41Z" fill="#ED5D23"/>
<path d="M60.4104 27.41H60.1104V35.28H60.4104V27.41Z" fill="#ED5C23"/>
<path d="M60.7102 27.41H60.4102V35.28H60.7102V27.41Z" fill="#ED5B23"/>
<path d="M61.01 27.41H60.71V35.28H61.01V27.41Z" fill="#EC5B23"/>
<path d="M61.3103 27.41H61.0103V35.28H61.3103V27.41Z" fill="#EC5A23"/>
<path d="M61.6003 27.41H61.3003V35.28H61.6003V27.41Z" fill="#EC5923"/>
<path d="M61.9001 27.41H61.6001V35.28H61.9001V27.41Z" fill="#EB5823"/>
<path d="M62.2004 27.41H61.9004V35.28H62.2004V27.41Z" fill="#EB5723"/>
<path d="M62.5002 27.41H62.2002V35.28H62.5002V27.41Z" fill="#EB5723"/>
<path d="M62.8 27.41H62.5V35.28H62.8V27.41Z" fill="#EA5623"/>
<path d="M63.09 27.41H62.79V35.28H63.09V27.41Z" fill="#EA5523"/>
<path d="M63.3903 27.41H63.0903V35.28H63.3903V27.41Z" fill="#EA5423"/>
<path d="M63.6901 27.41H63.3901V35.28H63.6901V27.41Z" fill="#E95323"/>
<path d="M63.9899 27.41H63.6899V35.28H63.9899V27.41Z" fill="#E95223"/>
<path d="M64.2902 27.41H63.9902V35.28H64.2902V27.41Z" fill="#E85123"/>
<path d="M64.5803 27.41H64.2803V35.28H64.5803V27.41Z" fill="#E85023"/>
<path d="M64.8801 27.41H64.5801V35.28H64.8801V27.41Z" fill="#E74F23"/>
<path d="M65.1804 27.41H64.8804V35.28H65.1804V27.41Z" fill="#E74E23"/>
<path d="M65.4802 27.41H65.1802V35.28H65.4802V27.41Z" fill="#E74C23"/>
<path d="M65.78 27.41H65.48V35.28H65.78V27.41Z" fill="#E64B23"/>
<path d="M66.07 27.41H65.77V35.28H66.07V27.41Z" fill="#E64A23"/>
<path d="M66.3703 27.41H66.0703V35.28H66.3703V27.41Z" fill="#E54923"/>
<path d="M66.6701 27.41H66.3701V35.28H66.6701V27.41Z" fill="#E54823"/>
<path d="M66.9699 27.41H66.6699V35.28H66.9699V27.41Z" fill="#E44723"/>
<path d="M67.2702 27.41H66.9702V35.28H67.2702V27.41Z" fill="#E44523"/>
<path d="M67.5602 27.41H67.2603V35.28H67.5602V27.41Z" fill="#E34423"/>
<path d="M67.8601 27.41H67.5601V35.28H67.8601V27.41Z" fill="#E34323"/>
<path d="M68.1604 27.41H67.8604V35.28H68.1604V27.41Z" fill="#E24123"/>
<path d="M68.4602 27.41H68.1602V35.28H68.4602V27.41Z" fill="#E14023"/>
<path d="M68.76 27.41H68.46V35.28H68.76V27.41Z" fill="#E13F23"/>
<path d="M69.05 27.41H68.75V35.28H69.05V27.41Z" fill="#E03D23"/>
<path d="M69.3503 27.41H69.0503V35.28H69.3503V27.41Z" fill="#E03C23"/>
<path d="M69.6501 27.41H69.3501V35.28H69.6501V27.41Z" fill="#DF3B23"/>
<path d="M69.9504 27.41H69.6504V35.28H69.9504V27.41Z" fill="#DF3923"/>
<path d="M70.2502 27.41H69.9502V35.28H70.2502V27.41Z" fill="#DE3823"/>
<path d="M70.5402 27.41H70.2402V35.28H70.5402V27.41Z" fill="#DD3623"/>
<path d="M70.84 27.41H70.54V35.28H70.84V27.41Z" fill="#DD3523"/>
<path d="M71.1403 27.41H70.8403V35.28H71.1403V27.41Z" fill="#DC3323"/>
<path d="M71.4401 27.41H71.1401V35.28H71.4401V27.41Z" fill="#DC3223"/>
<path d="M71.7399 27.41H71.4399V35.28H71.7399V27.41Z" fill="#DB3023"/>
<path d="M72.03 27.41H71.73V35.28H72.03V27.41Z" fill="#DA2F23"/>
<path d="M72.3303 27.41H72.0303V35.28H72.3303V27.41Z" fill="#DA2D23"/>
<path d="M72.6301 27.41H72.3301V35.28H72.6301V27.41Z" fill="#D92B23"/>
<path d="M72.9304 27.41H72.6304V35.28H72.9304V27.41Z" fill="#D82A23"/>
<path d="M73.2302 27.41H72.9302V35.28H73.2302V27.41Z" fill="#D82823"/>
<path d="M73.5202 27.41H73.2202V35.28H73.5202V27.41Z" fill="#D72623"/>
<path d="M73.82 27.41H73.52V35.28H73.82V27.41Z" fill="#D62523"/>
<path d="M74.1203 27.41H73.8203V35.28H74.1203V27.41Z" fill="#D52323"/>
<path d="M74.4201 27.41H74.1201V35.28H74.4201V27.41Z" fill="#D52123"/>
<path d="M74.7199 27.41H74.4199V35.28H74.7199V27.41Z" fill="#D41F23"/>
<path d="M75.01 27.41H74.71V35.28H75.01V27.41Z" fill="#D31E23"/>
<path d="M75.3102 27.41H75.0103V35.28H75.3102V27.41Z" fill="#D31C23"/>
<path d="M75.6101 27.41H75.3101V35.28H75.6101V27.41Z" fill="#D21A23"/>
<path d="M75.9104 27.41H75.6104V35.28H75.9104V27.41Z" fill="#D11823"/>
<path d="M75.9202 27.41H75.9102V35.28H75.9202V27.41Z" fill="#D11823"/>
</g>
<mask id="mask1_135_4986" style="mask-type:luminance" maskUnits="userSpaceOnUse" x="46" y="41" width="30" height="9">
<path d="M75.92 41.31H46.5V49.18H75.92V41.31Z" fill="white"/>
</mask>
<g mask="url(#mask1_135_4986)">
<path d="M46.88 41.31H46.5V49.18H46.88V41.31Z" fill="#F16623"/>
<path d="M47.2501 41.31H46.8701V49.18H47.2501V41.31Z" fill="#F16623"/>
<path d="M47.63 41.31H47.25V49.18H47.63V41.31Z" fill="#F16623"/>
<path d="M48.0099 41.31H47.6299V49.18H48.0099V41.31Z" fill="#F16623"/>
<path d="M48.3898 41.31H48.0098V49.18H48.3898V41.31Z" fill="#F16623"/>
<path d="M48.7599 41.31H48.3799V49.18H48.7599V41.31Z" fill="#F16523"/>
<path d="M49.1398 41.31H48.7598V49.18H49.1398V41.31Z" fill="#F16523"/>
<path d="M49.5201 41.31H49.1401V49.18H49.5201V41.31Z" fill="#F16523"/>
<path d="M49.8898 41.31H49.5098V49.18H49.8898V41.31Z" fill="#F16523"/>
<path d="M50.2701 41.31H49.8901V49.18H50.2701V41.31Z" fill="#F06523"/>
<path d="M50.65 41.31H50.27V49.18H50.65V41.31Z" fill="#F06423"/>
<path d="M51.0201 41.31H50.6401V49.18H51.0201V41.31Z" fill="#F06423"/>
<path d="M51.4 41.31H51.02V49.18H51.4V41.31Z" fill="#F06323"/>
<path d="M51.7799 41.31H51.3999V49.18H51.7799V41.31Z" fill="#F06323"/>
<path d="M52.1598 41.31H51.7798V49.18H52.1598V41.31Z" fill="#F06323"/>
<path d="M52.5299 41.31H52.1499V49.18H52.5299V41.31Z" fill="#EF6223"/>
<path d="M52.9098 41.31H52.5298V49.18H52.9098V41.31Z" fill="#EF6223"/>
<path d="M53.2902 41.31H52.9102V49.18H53.2902V41.31Z" fill="#EF6123"/>
<path d="M53.6598 41.31H53.2798V49.18H53.6598V41.31Z" fill="#EF6123"/>
<path d="M54.0402 41.31H53.6602V49.18H54.0402V41.31Z" fill="#EF6023"/>
<path d="M54.42 41.31H54.04V49.18H54.42V41.31Z" fill="#EE5F23"/>
<path d="M54.7902 41.31H54.4102V49.18H54.7902V41.31Z" fill="#EE5F23"/>
<path d="M55.17 41.31H54.79V49.18H55.17V41.31Z" fill="#EE5E23"/>
<path d="M55.5499 41.31H55.1699V49.18H55.5499V41.31Z" fill="#EE5E23"/>
<path d="M55.9298 41.31H55.5498V49.18H55.9298V41.31Z" fill="#ED5D23"/>
<path d="M56.2999 41.31H55.9199V49.18H56.2999V41.31Z" fill="#ED5C23"/>
<path d="M56.6798 41.31H56.2998V49.18H56.6798V41.31Z" fill="#ED5B23"/>
<path d="M57.0602 41.31H56.6802V49.18H57.0602V41.31Z" fill="#EC5B23"/>
<path d="M57.4298 41.31H57.0498V49.18H57.4298V41.31Z" fill="#EC5A23"/>
<path d="M57.8102 41.31H57.4302V49.18H57.8102V41.31Z" fill="#EC5923"/>
<path d="M58.1901 41.31H57.8101V49.18H58.1901V41.31Z" fill="#EB5823"/>
<path d="M58.5602 41.31H58.1802V49.18H58.5602V41.31Z" fill="#EB5723"/>
<path d="M58.9401 41.31H58.5601V49.18H58.9401V41.31Z" fill="#EB5723"/>
<path d="M59.3199 41.31H58.9399V49.18H59.3199V41.31Z" fill="#EA5623"/>
<path d="M59.6998 41.31H59.3198V49.18H59.6998V41.31Z" fill="#EA5523"/>
<path d="M60.0699 41.31H59.6899V49.18H60.0699V41.31Z" fill="#EA5423"/>
<path d="M60.4498 41.31H60.0698V49.18H60.4498V41.31Z" fill="#E95323"/>
<path d="M60.8302 41.31H60.4502V49.18H60.8302V41.31Z" fill="#E95223"/>
<path d="M61.1998 41.31H60.8198V49.18H61.1998V41.31Z" fill="#E85123"/>
<path d="M61.5802 41.31H61.2002V49.18H61.5802V41.31Z" fill="#E85023"/>
<path d="M61.9601 41.31H61.5801V49.18H61.9601V41.31Z" fill="#E74F23"/>
<path d="M62.3302 41.31H61.9502V49.18H62.3302V41.31Z" fill="#E74E23"/>
<path d="M62.7101 41.31H62.3301V49.18H62.7101V41.31Z" fill="#E74C23"/>
<path d="M63.09 41.31H62.71V49.18H63.09V41.31Z" fill="#E64B23"/>
<path d="M63.4698 41.31H63.0898V49.18H63.4698V41.31Z" fill="#E64A23"/>
<path d="M63.84 41.31H63.46V49.18H63.84V41.31Z" fill="#E54923"/>
<path d="M64.2198 41.31H63.8398V49.18H64.2198V41.31Z" fill="#E54823"/>
<path d="M64.6002 41.31H64.2202V49.18H64.6002V41.31Z" fill="#E44723"/>
<path d="M64.9698 41.31H64.5898V49.18H64.9698V41.31Z" fill="#E44523"/>
<path d="M65.3502 41.31H64.9702V49.18H65.3502V41.31Z" fill="#E34423"/>
<path d="M65.7301 41.31H65.3501V49.18H65.7301V41.31Z" fill="#E34323"/>
<path d="M66.1002 41.31H65.7202V49.18H66.1002V41.31Z" fill="#E24123"/>
<path d="M66.4801 41.31H66.1001V49.18H66.4801V41.31Z" fill="#E14023"/>
<path d="M66.86 41.31H66.48V49.18H66.86V41.31Z" fill="#E13F23"/>
<path d="M67.2399 41.31H66.8599V49.18H67.2399V41.31Z" fill="#E03D23"/>
<path d="M67.61 41.31H67.23V49.18H67.61V41.31Z" fill="#E03C23"/>
<path d="M67.9899 41.31H67.6099V49.18H67.9899V41.31Z" fill="#DF3B23"/>
<path d="M68.3702 41.31H67.9902V49.18H68.3702V41.31Z" fill="#DF3923"/>
<path d="M68.7399 41.31H68.3599V49.18H68.7399V41.31Z" fill="#DE3823"/>
<path d="M69.1202 41.31H68.7402V49.18H69.1202V41.31Z" fill="#DD3623"/>
<path d="M69.5001 41.31H69.1201V49.18H69.5001V41.31Z" fill="#DD3523"/>
<path d="M69.8702 41.31H69.4902V49.18H69.8702V41.31Z" fill="#DC3323"/>
<path d="M70.2501 41.31H69.8701V49.18H70.2501V41.31Z" fill="#DC3223"/>
<path d="M70.63 41.31H70.25V49.18H70.63V41.31Z" fill="#DB3023"/>
<path d="M71.0099 41.31H70.6299V49.18H71.0099V41.31Z" fill="#DA2F23"/>
<path d="M71.38 41.31H71V49.18H71.38V41.31Z" fill="#DA2D23"/>
<path d="M71.7599 41.31H71.3799V49.18H71.7599V41.31Z" fill="#D92B23"/>
<path d="M72.1398 41.31H71.7598V49.18H72.1398V41.31Z" fill="#D82A23"/>
<path d="M72.5099 41.31H72.1299V49.18H72.5099V41.31Z" fill="#D82823"/>
<path d="M72.8898 41.31H72.5098V49.18H72.8898V41.31Z" fill="#D72623"/>
<path d="M73.2701 41.31H72.8901V49.18H73.2701V41.31Z" fill="#D62523"/>
<path d="M73.6398 41.31H73.2598V49.18H73.6398V41.31Z" fill="#D52323"/>
<path d="M74.0201 41.31H73.6401V49.18H74.0201V41.31Z" fill="#D52123"/>
<path d="M74.4 41.31H74.02V49.18H74.4V41.31Z" fill="#D41F23"/>
<path d="M74.7799 41.31H74.3999V49.18H74.7799V41.31Z" fill="#D31E23"/>
<path d="M75.15 41.31H74.77V49.18H75.15V41.31Z" fill="#D31C23"/>
<path d="M75.5299 41.31H75.1499V49.18H75.5299V41.31Z" fill="#D21A23"/>
<path d="M75.9098 41.31H75.5298V49.18H75.9098V41.31Z" fill="#D11823"/>
<path d="M75.9199 41.31H75.8999V49.18H75.9199V41.31Z" fill="#D11823"/>
</g>
<mask id="mask2_135_4986" style="mask-type:luminance" maskUnits="userSpaceOnUse" x="10" y="42" width="49" height="46">
<path d="M49 87.5L34.29 79.73L19.56 87.5L22.4 71.09L10.46 59.49L26.94 57.11L34.29 42.17L41.64 57.11L58.12 59.49L46.18 71.09L49 87.5ZM22.69 63.94L28.5 69.58L27.12 77.58L34.29 73.8L41.45 77.58L40.08 69.58L45.88 63.94L37.88 62.78L34.31 55.51L30.74 62.78L22.69 63.94Z" fill="white"/>
</mask>
<g mask="url(#mask2_135_4986)">
<path d="M27.5602 60H27.4102V73.09H27.5602V60Z" fill="#EC5B23"/>
<path d="M28.1701 60H27.5601V73.09H28.1701V60Z" fill="#EC5A23"/>
<path d="M28.7799 60H28.1699V73.09H28.7799V60Z" fill="#EC5923"/>
<path d="M29.3898 60H28.7798V73.09H29.3898V60Z" fill="#EB5823"/>
<path d="M30.0001 60H29.3901V73.09H30.0001V60Z" fill="#EB5723"/>
<path d="M30.61 60H30V73.09H30.61V60Z" fill="#EB5723"/>
<path d="M31.2199 60H30.6099V73.09H31.2199V60Z" fill="#EA5623"/>
<path d="M31.8297 60H31.2197V73.09H31.8297V60Z" fill="#EA5523"/>
<path d="M32.4498 60H31.8398V73.09H32.4498V60Z" fill="#EA5423"/>
<path d="M33.0602 60H32.4502V73.09H33.0602V60Z" fill="#E95323"/>
<path d="M33.6701 60H33.0601V73.09H33.6701V60Z" fill="#E95223"/>
<path d="M34.2799 60H33.6699V73.09H34.2799V60Z" fill="#E85123"/>
<path d="M34.8898 60H34.2798V73.09H34.8898V60Z" fill="#E85023"/>
<path d="M35.5001 60H34.8901V73.09H35.5001V60Z" fill="#E74F23"/>
<path d="M36.11 60H35.5V73.09H36.11V60Z" fill="#E74E23"/>
<path d="M36.7199 60H36.1099V73.09H36.7199V60Z" fill="#E74C23"/>
<path d="M37.3297 60H36.7197V73.09H37.3297V60Z" fill="#E64B23"/>
<path d="M37.9401 60H37.3301V73.09H37.9401V60Z" fill="#E64A23"/>
<path d="M38.5499 60H37.9399V73.09H38.5499V60Z" fill="#E54923"/>
<path d="M39.1598 60H38.5498V73.09H39.1598V60Z" fill="#E54823"/>
<path d="M39.7702 60H39.1602V73.09H39.7702V60Z" fill="#E44723"/>
<path d="M40.38 60H39.77V73.09H40.38V60Z" fill="#E44523"/>
<path d="M41.0001 60H40.3901V73.09H41.0001V60Z" fill="#E34423"/>
<path d="M41.17 60H41V73.09H41.17V60Z" fill="#E34323"/>
<path d="M11.07 42.17H10.46V87.5H11.07V42.17Z" fill="#F16623"/>
<path d="M11.6798 42.17H11.0698V87.5H11.6798V42.17Z" fill="#F16623"/>
<path d="M12.2902 42.17H11.6802V87.5H12.2902V42.17Z" fill="#F16623"/>
<path d="M12.9 42.17H12.29V87.5H12.9V42.17Z" fill="#F16623"/>
<path d="M13.5099 42.17H12.8999V87.5H13.5099V42.17Z" fill="#F16623"/>
<path d="M14.1198 42.17H13.5098V87.5H14.1198V42.17Z" fill="#F16523"/>
<path d="M14.7301 42.17H14.1201V87.5H14.7301V42.17Z" fill="#F16523"/>
<path d="M15.34 42.17H14.73V87.5H15.34V42.17Z" fill="#F16523"/>
<path d="M15.9601 42.17H15.3501V87.5H15.9601V42.17Z" fill="#F16523"/>
<path d="M16.57 42.17H15.96V87.5H16.57V42.17Z" fill="#F06523"/>
<path d="M17.1798 42.17H16.5698V87.5H17.1798V42.17Z" fill="#F06423"/>
<path d="M17.7902 42.17H17.1802V87.5H17.7902V42.17Z" fill="#F06423"/>
<path d="M18.4 42.17H17.79V87.5H18.4V42.17Z" fill="#F06323"/>
<path d="M19.0099 42.17H18.3999V87.5H19.0099V42.17Z" fill="#F06323"/>
<path d="M19.6198 42.17H19.0098V87.5H19.6198V42.17Z" fill="#F06323"/>
<path d="M20.2301 42.17H19.6201V87.5H20.2301V42.17Z" fill="#EF6223"/>
<path d="M20.84 42.17H20.23V87.5H20.84V42.17Z" fill="#EF6223"/>
<path d="M21.4498 42.17H20.8398V87.5H21.4498V42.17Z" fill="#EF6123"/>
<path d="M22.0602 42.17H21.4502V87.5H22.0602V42.17Z" fill="#EF6123"/>
<path d="M22.6701 42.17H22.0601V87.5H22.6701V42.17Z" fill="#EF6023"/>
<path d="M23.2799 42.17H22.6699V87.5H23.2799V42.17Z" fill="#EE5F23"/>
<path d="M23.9 42.17H23.29V87.5H23.9V42.17Z" fill="#EE5F23"/>
<path d="M24.5099 42.17H23.8999V87.5H24.5099V42.17Z" fill="#EE5E23"/>
<path d="M25.1198 42.17H24.5098V87.5H25.1198V42.17Z" fill="#EE5E23"/>
<path d="M25.7301 42.17H25.1201V87.5H25.7301V42.17Z" fill="#ED5D23"/>
<path d="M26.34 42.17H25.73V87.5H26.34V42.17Z" fill="#ED5C23"/>
<path d="M26.9498 42.17H26.3398V87.5H26.9498V42.17Z" fill="#ED5B23"/>
<path d="M27.5602 42.17H26.9502V87.5H27.5602V42.17Z" fill="#EC5B23"/>
<path d="M28.1701 42.17H27.5601V87.5H28.1701V42.17Z" fill="#EC5A23"/>
<path d="M28.7799 42.17H28.1699V87.5H28.7799V42.17Z" fill="#EC5923"/>
<path d="M29.3898 42.17H28.7798V87.5H29.3898V42.17Z" fill="#EB5823"/>
<path d="M30.0001 42.17H29.3901V87.5H30.0001V42.17Z" fill="#EB5723"/>
<path d="M30.61 42.17H30V87.5H30.61V42.17Z" fill="#EB5723"/>
<path d="M31.2199 42.17H30.6099V87.5H31.2199V42.17Z" fill="#EA5623"/>
<path d="M31.8297 42.17H31.2197V87.5H31.8297V42.17Z" fill="#EA5523"/>
<path d="M32.4498 42.17H31.8398V87.5H32.4498V42.17Z" fill="#EA5423"/>
<path d="M33.0602 42.17H32.4502V87.5H33.0602V42.17Z" fill="#E95323"/>
<path d="M33.6701 42.17H33.0601V87.5H33.6701V42.17Z" fill="#E95223"/>
<path d="M34.2799 42.17H33.6699V87.5H34.2799V42.17Z" fill="#E85123"/>
<path d="M34.8898 42.17H34.2798V87.5H34.8898V42.17Z" fill="#E85023"/>
<path d="M35.5001 42.17H34.8901V87.5H35.5001V42.17Z" fill="#E74F23"/>
<path d="M36.11 42.17H35.5V87.5H36.11V42.17Z" fill="#E74E23"/>
<path d="M36.7199 42.17H36.1099V87.5H36.7199V42.17Z" fill="#E74C23"/>
<path d="M37.3297 42.17H36.7197V87.5H37.3297V42.17Z" fill="#E64B23"/>
<path d="M37.9401 42.17H37.3301V87.5H37.9401V42.17Z" fill="#E64A23"/>
<path d="M38.5499 42.17H37.9399V87.5H38.5499V42.17Z" fill="#E54923"/>
<path d="M39.1598 42.17H38.5498V87.5H39.1598V42.17Z" fill="#E54823"/>
<path d="M39.7702 42.17H39.1602V87.5H39.7702V42.17Z" fill="#E44723"/>
<path d="M40.38 42.17H39.77V87.5H40.38V42.17Z" fill="#E44523"/>
<path d="M41.0001 42.17H40.3901V87.5H41.0001V42.17Z" fill="#E34423"/>
<path d="M41.61 42.17H41V87.5H41.61V42.17Z" fill="#E34323"/>
<path d="M42.2199 42.17H41.6099V87.5H42.2199V42.17Z" fill="#E24123"/>
<path d="M42.8297 42.17H42.2197V87.5H42.8297V42.17Z" fill="#E14023"/>
<path d="M43.4401 42.17H42.8301V87.5H43.4401V42.17Z" fill="#E13F23"/>
<path d="M44.0499 42.17H43.4399V87.5H44.0499V42.17Z" fill="#E03D23"/>
<path d="M44.6598 42.17H44.0498V87.5H44.6598V42.17Z" fill="#E03C23"/>
<path d="M45.2702 42.17H44.6602V87.5H45.2702V42.17Z" fill="#DF3B23"/>
<path d="M45.88 42.17H45.27V87.5H45.88V42.17Z" fill="#DF3923"/>
<path d="M46.4899 42.17H45.8799V87.5H46.4899V42.17Z" fill="#DE3823"/>
<path d="M47.0997 42.17H46.4897V87.5H47.0997V42.17Z" fill="#DD3623"/>
<path d="M47.7101 42.17H47.1001V87.5H47.7101V42.17Z" fill="#DD3523"/>
<path d="M48.32 42.17H47.71V87.5H48.32V42.17Z" fill="#DC3323"/>
<path d="M48.9401 42.17H48.3301V87.5H48.9401V42.17Z" fill="#DC3223"/>
<path d="M49.5499 42.17H48.9399V87.5H49.5499V42.17Z" fill="#DB3023"/>
<path d="M50.1598 42.17H49.5498V87.5H50.1598V42.17Z" fill="#DA2F23"/>
<path d="M50.7702 42.17H50.1602V87.5H50.7702V42.17Z" fill="#DA2D23"/>
<path d="M51.38 42.17H50.77V87.5H51.38V42.17Z" fill="#D92B23"/>
<path d="M51.9899 42.17H51.3799V87.5H51.9899V42.17Z" fill="#D82A23"/>
<path d="M52.5997 42.17H51.9897V87.5H52.5997V42.17Z" fill="#D82823"/>
<path d="M53.2101 42.17H52.6001V87.5H53.2101V42.17Z" fill="#D72623"/>
<path d="M53.82 42.17H53.21V87.5H53.82V42.17Z" fill="#D62523"/>
<path d="M54.4298 42.17H53.8198V87.5H54.4298V42.17Z" fill="#D52323"/>
<path d="M55.0402 42.17H54.4302V87.5H55.0402V42.17Z" fill="#D52123"/>
<path d="M55.65 42.17H55.04V87.5H55.65V42.17Z" fill="#D41F23"/>
<path d="M56.2599 42.17H55.6499V87.5H56.2599V42.17Z" fill="#D31E23"/>
<path d="M56.8698 42.17H56.2598V87.5H56.8698V42.17Z" fill="#D31C23"/>
<path d="M57.4899 42.17H56.8799V87.5H57.4899V42.17Z" fill="#D21A23"/>
<path d="M58.0997 42.17H57.4897V87.5H58.0997V42.17Z" fill="#D11823"/>
<path d="M58.1201 42.17H58.1001V87.5H58.1201V42.17Z" fill="#D11823"/>
</g>
</svg>
</template>
